<template>
  <div class="counts d-flex justify-content-evenly">
    <div
      v-for="(count, index) in filteredCounts"
      :key="index"
      class="d-flex align-items-center gap-1"
      :class="count.color"
    >
      <component class="count-icon" :is="count.icon" :size="30" />
      <p class="count-text" :style="{ fontSize: `2rem` }">
        {{ count.value }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScannedListCounts",
  props: {
    counts: {
      type: Array,
      required: true
    }
  },

  computed: {
    filteredCounts() {
      return this.counts.filter(({ value }) => value > 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.counts {
  padding-block: 1rem;
  overflow-x: hidden;
}

.count {
  &-icon {
    line-height: 1;
  }

  &-text {
    font-weight: 700;
  }
}
</style>
